/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2021-09-01 14:12:39
 * @LastEditors: zhanghang
 * @LastEditTime: 2021-09-14 17:05:18
 */

export const DsfNavCatalogue = dsf.defineLazyComponent("DsfNavCatalogue", () =>
  require("./navCatalogue")
);

export const DsfNavMenu = dsf.defineAsyncComponent("DsfNavMenu", () =>
  import(/* webpackChunkName: "platform_pc_nav" */ "./navMenu.js")
);
export const DsfCalendarNav = dsf.defineAsyncComponent("DsfCalendarNav", () =>
  import(/* webpackChunkName: "platform_pc_nav" */ "./calendarNav")
);
export const DsfBanner = dsf.defineAsyncComponent("DsfBanner", () =>
  import(/* webpackChunkName: "platform_pc_nav" */ "./banner.vue")
);
export const DsfIndicatorPanel = dsf.defineLazyComponent("DsfIndicatorPanel", () =>
  import(/* webpackChunkName: "platform_pc_nav" */ "./indicatorPanel")
);
export const DsfConvenientMenu = dsf.defineAsyncComponent("DsfConvenientMenu", () =>
  import(/* webpackChunkName: "platform_pc_nav" */ "./convenientMenu")
);
